/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { OutDealDTO } from "./OutDealDTO";
import { OutDealDTOFromJSON, OutDealDTOFromJSONTyped, OutDealDTOToJSON } from "./OutDealDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface OutProductExtendedViewDTO
 */
export interface OutProductExtendedViewDTO {
  /**
   *
   * @type {number}
   * @memberof OutProductExtendedViewDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  ean?: string;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutProductExtendedViewDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {boolean}
   * @memberof OutProductExtendedViewDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  slug: string;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutProductExtendedViewDTO
   */
  image?: ImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof OutProductExtendedViewDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  specification?: string;
  /**
   *
   * @type {Date}
   * @memberof OutProductExtendedViewDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof OutProductExtendedViewDTO
   */
  createdAt?: string;
  /**
   *
   * @type {Array<OutDealDTO>}
   * @memberof OutProductExtendedViewDTO
   */
  deals?: Array<OutDealDTO>;
}

/**
 * Check if a given object implements the OutProductExtendedViewDTO interface.
 */
export function instanceOfOutProductExtendedViewDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "slug" in value;

  return isInstance;
}

export function OutProductExtendedViewDTOFromJSON(json: any): OutProductExtendedViewDTO {
  return OutProductExtendedViewDTOFromJSONTyped(json, false);
}

export function OutProductExtendedViewDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutProductExtendedViewDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    live: json["live"],
    slug: json["slug"],
    image: !exists(json, "image") ? undefined : ImageDTOFromJSON(json["image"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    description: !exists(json, "description") ? undefined : json["description"],
    specification: !exists(json, "specification") ? undefined : json["specification"],
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    createdAt: !exists(json, "createdAt") ? undefined : json["createdAt"],
    deals: !exists(json, "deals") ? undefined : (json["deals"] as Array<any>).map(OutDealDTOFromJSON)
  };
}

export function OutProductExtendedViewDTOToJSON(value?: OutProductExtendedViewDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    title: value.title,
    ean: value.ean,
    platform: PublicPlatformDTOToJSON(value.platform),
    live: value.live,
    slug: value.slug,
    image: ImageDTOToJSON(value.image),
    seo: SeoDTOToJSON(value.seo),
    description: value.description,
    specification: value.specification,
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    createdAt: value.createdAt,
    deals: value.deals === undefined ? undefined : (value.deals as Array<any>).map(OutDealDTOToJSON)
  };
}
